<template lang="pug">
  .cta.pading-y-l
    //- .fz-h-l-2.t-center 订阅我们的最新动态
    //- .fz-p-m.t-center.color-text-2 第一时间体验更简单高效、轻松好玩的次世代创作。
    h6.fz-ll.lh-h.t-center Subscribe our newsletter
    p.fz-m.lh-p.t-center.color-text-2.t-center Be the first to experience the next-level content collaboration world.
    SignUp.sign-up-form

</template>


<style lang="stylus" scoped>
@require '../styles/layout/main'
@require '../styles/design/main'

.cta
  stack(y, gap:2rem, ali:center)
  max-width 100%
  min-width 100%
.sign-up-form
  width 560px
  max-width 100%

</style>

<script>
import SignUp from "@/components/signup.vue";
// import Share from "@/components/share.vue";

export default {
  components: {
    SignUp
    // Share
  }
};
</script>
